import { Trans, useTranslation } from "react-i18next";
import React, { useEffect, useMemo, useState } from "react";
import {
  Popup,
  PopupActions,
  PopupButton,
  PopupContent,
  PopupHeading,
} from "../../components/Common/Popup";
import Button from "../../components/Common/Button";
import { usePictureSets } from "../hooks/usePictureSets";
import { getClientType } from "../../utils";

const HasPicturesInPipelineDialog = (props) => {
  const { t } = useTranslation();
  const { currentPictureSet, isLoaded } = usePictureSets();
  const [dialogOpen, setDialogOpen] = useState(false);
  const client = getClientType();

  const handleSetNotificationShown = () => {
    const data = JSON.parse(
      sessionStorage.getItem("pipelineNotificationShown") || "{}",
    );
    data[currentPictureSet.subject.uuid] = true;
    sessionStorage.setItem("pipelineNotificationShown", JSON.stringify(data));
    setDialogOpen(false);
  };

  useEffect(() => {
    if (!currentPictureSet?.hasPicturesInPipeline) {
      return;
    }
    const data = JSON.parse(
      sessionStorage.getItem("pipelineNotificationShown") || "{}",
    );
    if (data[currentPictureSet.subject.uuid]) {
      setDialogOpen(false);
    } else {
      setDialogOpen(true);
    }
    return;
  }, [currentPictureSet]);

  console.log("The client is", client);

  // Disable for desktop:
  if (!dialogOpen || client == "desktop" || !isLoaded) {
    return null;
  }

  return (
    <Popup onClose={props.onClose}>
      <PopupHeading>
        <Trans>More pictures to come</Trans>
      </PopupHeading>
      <PopupContent>
        <p>
          {t("There are pictures of %s that are not ready yet.", {
            postProcess: "sprintf",
            sprintf: [currentPictureSet.subject.name],
          })}
        </p>
        <p>
          <Trans>We will notify you when these pictures are available.</Trans>
        </p>
      </PopupContent>

      <PopupActions>
        <PopupButton fullWidth onClick={handleSetNotificationShown}>
          <Trans>Ok</Trans>
        </PopupButton>
      </PopupActions>
    </Popup>
  );
};

export default HasPicturesInPipelineDialog;
